import React from "react";
import ReactDOM from "react-dom/client";
import { AuthProvider } from "context/Context";
import { Auth0Provider } from '@auth0/auth0-react';
import App from "App";
import "bootstrap/dist/css/bootstrap.min.css";
import "./assets/css/animate.min.css";
import "./assets/scss/light-bootstrap-dashboard-react.scss?v=2.0.0";
import "./assets/css/demo.css";
import "@fortawesome/fontawesome-free/css/all.min.css";
import { HolidayListContextProvider } from "context/HolidayListContext";
import { EmploymentHistoryContextProvider } from "context/EmploymentHistoryContext";
import { OffboardPopupContextProvider } from "context/OffboardPopupContext"
import { Provider } from "react-redux";
import { Store } from "../src/redux/Store";
import 'bootstrap-icons/font/bootstrap-icons.css';


const root = ReactDOM.createRoot(document.getElementById("root"));

root.render(
  <Provider store={Store}>
  <Auth0Provider
    domain={process.env.REACT_APP_AUTH0_DOMAIN}
    clientId={process.env.REACT_APP_AUTH0_CLIENT_ID}
    redirectUri={globalThis.location.origin}
    audience={process.env.REACT_APP_AUDIENCE_AUTH0}>
      <AuthProvider>
              <HolidayListContextProvider>
                <EmploymentHistoryContextProvider>
                  <OffboardPopupContextProvider>
                    <App />
                  </OffboardPopupContextProvider>
                </EmploymentHistoryContextProvider>
              </HolidayListContextProvider>
      </AuthProvider>
  </Auth0Provider>
  </Provider>
);


